export type AnnouncementRow = Record<string, unknown> & {
  id: number;
  title: string;
  description: string;
  eventType: string;
  presentedBy: string;
  startDateTime: string;
  endDateTime: string;
  venue: string;
  mode: string;
  status: string;
  attachment?: string | null;
  file?: string | null;
};

export function announcementAttachmentName(path: string | null | undefined): string | null {
  if (!path) return null;
  return path.split("/").reverse().find((part) => /\.(pdf|jpe?g|png)$/i.test(part)) ?? null;
}

export function announcementStatusVariant(status: string): "success" | "warning" | "danger" | "neutral" {
  switch (status.toUpperCase()) {
    case "ONGOING":
    case "APPROVED":
      return "success";
    case "UPCOMING":
    case "PENDING":
      return "warning";
    case "REJECTED":
      return "danger";
    default:
      return "neutral";
  }
}

export function announcementStatusLabel(status: string): string {
  switch (status.toUpperCase()) {
    case "APPROVED": return "Approved";
    case "PENDING": return "Pending";
    case "REJECTED": return "Rejected";
    case "UPCOMING": return "Upcoming";
    case "ONGOING": return "Ongoing";
    case "PAST": return "Past";
    default: return status;
  }
}
